import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { IHearingDate } from 'src/app/classes/hearing-date';
import { PublicService } from 'src/app/services/public.service';

@Component({
  selector: 'app-minutes-lookup',
  templateUrl: './minutes-lookup.component.html'
})
export class MinutesLookupComponent implements OnInit {

  hearingList: IHearingDate[];
  cols: any[];
  //
  curYear: number;
  yearList: string[];
  caseYear: number;
  //
  displayState: any = {
    workingDiv: false,
    gridDiv: false,
  };

  constructor(private publicService: PublicService, private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.cols = [
      { field: 'hearingDate', header: 'Hearing Date' },
      { field: 'hearingTime', header: 'Hearing Time' },
    ];
    this.curYear = (new Date()).getFullYear();
    this.getYearList(); // construct list of years made available for searching/editing - rod
    this.caseYear = this.curYear; // start out with the current year...
    this.getHearingList(this.caseYear);
  }
  goHome() {
    this.router.navigate(['/home']);
  }
  // generate a list of years to display, based on current year
  getYearList() {
    this.yearList = [];
    const baseYr = 1997;
    for (let yr = this.curYear; yr > baseYr; yr--) {
      this.yearList.push(yr.toString());
    }
  }
  getHearingList(year: number) {
    this.displayState.gridDiv = false;
    this.displayState.workingDiv = true;
    this.hearingList = [];
    this.publicService.doAudit(year,'getting list of hearing dates for year:');
    this.publicService.getHearingDatesForMinutes(year).subscribe(data => {
      this.publicService.doAudit(data, 'response from getHearingDatesForMinutes');
      this.displayState.workingDiv = false;
      if (data) {
        this.hearingList = data;
        if (data.length < 1) {
          return;
        }
      }
      this.displayState.gridDiv = true;
    });
  }

  // generate agenda document for selected hearing date
  onSelect(myHearing: IHearingDate) {
    const id = myHearing.id;
    this.publicService.generateMinutes(id).subscribe(data => {
      this.publicService.doAudit(data, 'response from generateMinutes');
      if (data) {
        const myUrl = URL.createObjectURL(data);
        window.open(myUrl, '_blank');
        URL.revokeObjectURL(myUrl);
      }
    });
  }
}
